<template>
  <div class="card h-100">
    <div class="card-header pb-0 p-3">
      <div class="row">
        <div class="col-6 d-flex align-items-center">
          <h6 class="mb-0">Latest Blog Post</h6>
        </div>
        <div class="col-6 text-end">
          <a
            v-if="post"
            :href="`/blog/${post.id}/edit`"
            class="btn btn-outline-primary btn-sm mb-0"
            >Edit</a
          >
        </div>
      </div>
    </div>
    <div class="card-body p-3 pb-0">
      <div v-if="post">
        <div class="position-relative">
          <a class="d-block shadow-xl border-radius-xl">
            <img
              :src="
                post.cover_image ||
                'https://demos.creative-tim.com/soft-ui-dashboard/assets/img/home-decor-1.jpg'
              "
              alt="img-blur-shadow"
              class="img-fluid shadow border-radius-xl"
            />
          </a>
        </div>
        <div class="p-3">
          <p class="text-sm mb-1 text-capitalize font-weight-bold">
            {{ post.created_at }}
          </p>
          <h5>{{ post.title }}</h5>
          <p class="mb-4 text-sm">
            {{ post.summary }}
          </p>
          <div class="d-flex align-items-center justify-content-between">
            <a
              :href="`/blog/posts/${post.id}/edit`"
              class="btn btn-outline-primary btn-sm mb-0"
              >View Post</a
            >
          </div>
        </div>
      </div>
      <div v-else class="text-center py-4">
        <p>No blog posts found.</p>
        <a href="/blog/posts/create" class="btn btn-primary btn-sm"
          >Create New Post</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "blog-post-card",
  props: {
    post: {
      type: Object,
      default: null,
    },
  },
};
</script>
